/*
 * Copyright (c) 2025 Valsoft Corp DBA Fusion Data Hub. All rights reserved.
 *
 * This software is the confidential and proprietary information of Valsoft Corp DBA Fusion Data Hub
 * ("Confidential Information"). You shall not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement you entered
 * into with Valsoft Corp DBA Fusion Data Hub.
 *
 * Unauthorized use, duplication, or distribution is strictly prohibited.
 *
 * RESTRICTED RIGHTS LEGEND:
 * Use, duplication, or disclosure by the Government is subject to restrictions
 * as set forth in subparagraph (c)(1)(ii) of the Rights in Technical Data and
 * Computer Software clause at DFARS 252.227-7013.
 *
 * Valsoft Corp DBA Fusion Data Hub
 * 7405 Rte Transcanadienne Suite 100 Montreal, QC, H4T 1Z2 Canada
 */

import { bootstrap } from '@ms-fabric/workload-client';
import './i18n';

function printFormattedAADErrorMessage(hashMessage: string): void {
    const hashString = hashMessage.slice(1);

    // Decode URL encoding and parse key-value pairs
    const searchParams = new URLSearchParams(hashString);
    const formattedMessage: Record<string, string> = {};

    searchParams.forEach((value, key) => {
        formattedMessage[key] = decodeURIComponent(value);
    });

    // Print formatted message
    document.documentElement.innerHTML = "There was a problem with the consent, open browser debug console for more details";
    for (const key in formattedMessage) {
        if (Object.prototype.hasOwnProperty.call(formattedMessage, key)) {
            console.log(`${key}: ${formattedMessage[key]}`);
        }
    }
}

/** This is used for authentication API as a redirect URI.
 * Delete this code if you do not plan on using authentication API.
 * You can change the redirectUriPath to whatever suits you.
 */
const redirectUriPath = '/close';
const url = new URL(window.location.href);
if (url.pathname?.startsWith(redirectUriPath)) {
    // Handle errors, Please refer to https://learn.microsoft.com/en-us/entra/identity-platform/reference-error-codes
    if (url?.hash?.includes("error")) {
        // Handle missing service principal error
        if (url.hash.includes("AADSTS650052")) {
            printFormattedAADErrorMessage(url?.hash);
            // handle user declined the consent error
        } else if (url.hash.includes("AADSTS65004")) {
            printFormattedAADErrorMessage(url?.hash);
        } else {
            window.close();
        }

    } else {
        // close the window in case there are no errors
        window.close();
    }
}

console.log('****Runtime: Environment Variables****');
console.log('process.env.WORKLOAD_NAME: ' + process.env.WORKLOAD_NAME);
console.log('process.env.WORKLOAD_BE_URL: ' + process.env.WORKLOAD_BE_URL);
console.log('**************************************');

bootstrap({
    initializeWorker: (params) =>
        import('./index.worker').then(({ initialize }) => initialize(params)),
    initializeUI: (params) =>
        import('./index.ui').then(({ initialize }) => initialize(params)),
});
